import React, { useContext } from 'react';
import Button from '../Button/Button';
import { Context } from '../Context/withContext';
import { FormDataContext } from '../FormDataContext/WithFormDataContext';
import RequestResult from '../RequestResult/RequestResult';

const AmountPart3 = () => {
  //eslint-disable-next-line
  const [formData, setFormData] = useContext(FormDataContext);
  const [stepNumber, setStepNumber] = useContext(Context);

  if (formData.totalAffordableAmount > 0) {
    return (
      <div className="flex flex-col items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="text-suzGreen h-16 w-16 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p className="mb-12 text-2xl tracking-widest uppercase text-white">
          Congratulations! You have been pre-approved for the amount of:
        </p>
        <p className="mb-12 text-3xl tracking-widest text-suzGreen">
          R{formData.totalAffordableAmount}
        </p>
        <p className="text-2xl tracking-widest text-white">
          Proceed with your application:
        </p>
        <div className="flex justify-center mt-4">
          <Button
            text="CHOOSE A VEHICLE"
            action={() => {
              setStepNumber(stepNumber + 1);
            }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <RequestResult
        result={formData.financeResponse ? formData.financeResponse : 'E'}
      />
    );
  }
};

export default AmountPart3;
